const APP_ID = '39569';
const APP_SOURCE = `//fast.appcues.com/${APP_ID}.js`;

export function insertAppcues({
  plan_id,
  benchmarks_id,
  user_id,
  benchmarks,
  user,
}) {
  window.Appcues.identify(user_id, {
    admin: user.admin,
    avatarUrl: user.avatarUrl,
    planId: plan_id,
    benchmarkId: benchmarks_id,
    createdAt: user.createdAt,
    initialPasswordChanged: user.initialPasswordChanged,
    intercomHash: user.intercomHash,
    master: user.master,
    userName: user.name,
    paymentKind: user.paymentKind,
    roleId: user.roleId,
    userGroup: user.userGroup,
    name: user.name,
    email: user.email,
    benchmarks,
  });
}

export function insertAppcuesPlugin(userData) {
  /* eslint-disable */
  (function() {    
    const scriptList = document.getElementsByTagName('script');

    if (!isThereAppcuesTag(scriptList)) {
      const [firstScript] = scriptList;
      const appcuesScript = document.createElement('script');
      appcuesScript.id = APP_SOURCE;
      appcuesScript.async = true;
      appcuesScript.defer = true;
      appcuesScript.src = APP_SOURCE;
      firstScript.parentNode.insertBefore(appcuesScript, firstScript);

      window.AppcuesSettings = {
        enableURLDetection: true,
      };
    }
  }());

  const appcues = appcuesPromisse();
  appcues.then(() => {
    insertAppcues(userData);
  });
}

function isThereAppcuesTag(scriptList) {
  return scriptList.namedItem(APP_SOURCE);
}

function appcuesPromisse() {
  return new Promise((resolve, reject) => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if(mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          const [addedNode,] = mutation.addedNodes;

          if(isAppcuesScriptTag(addedNode)) {
            resolve();
          }
        }
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    })
  });
}

function isAppcuesScriptTag(addedNode) {
  const regex = /sha256-/u;

  return addedNode.tagName === 'SCRIPT'
  && addedNode.crossOrigin === 'anonymous'
  && addedNode.integrity.match(regex);
}